import { combineReducers } from 'redux';
import admins from './admins';
import users from './users';
import algos from './algos';
import algosUniversal from './algos-universal';
import healthStatus from './health-status';
import masterContracts from './master-contracts';
import config from './config';
import faqTopics from './faq-topics';
import faqs from './faqs';
import orderBook from './order-book';
import payouts from './payouts';
import coupons from './coupons';
import credits from './credits';
import twitterPost from '../../stores/twitter-post/reducers';
import reports from '../../stores/reports/reducers';
import instance from '../../stores/instance/reducers';
import theme from '../../stores/theme/reducers';
import metaComponents from '../../stores/meta-components/reducers';
import jobs from './jobs';
import subscriptionHistory from '../../stores/subscription-history/reducers';
import signupPage from '../../stores/signup-pages/reducers';
import referredUsers from '../../stores/referred-users/reducers';
import notificationMonitoring from '../../stores/notification-monitoring/reducers';
import generateLoginLink from '../../stores/generate-login-link/reducers';
import signalsList from '../../stores/signals/signals-list/reducers';
import signalsDetails from '../../stores/signals/signal-details/reducers';
import expiryDates from '../../stores/expiry-dates/reducers';
import brokerSettings from '../../stores/broker-settings/reducers';
import announcements from '../../stores/announcements/reducers';
import userLogin2fa from '../../stores/user-login-2fa/reducers';
import brokerOmsRequest from '../../stores/broker-oms-request/reducers';
import masterContractsAll from '../../stores/master-contracts-all/reducers';

const rootReducer = combineReducers({
  admins,
  users,
  algos,
  algosUniversal,
  healthStatus,
  masterContracts,
  config,
  faqTopics,
  faqs,
  orderBook,
  payouts,
  coupons,
  credits,
  twitterPost,
  reports,
  instance,
  theme,
  jobs,
  metaComponents,
  announcements,
  subscriptionHistory,
  signupPage,
  referredUsers,
  notificationMonitoring,
  generateLoginLink,
  signalsList,
  signalsDetails,
  expiryDates,
  brokerSettings,
  userLogin2fa,
  brokerOmsRequest,
  masterContractsAll,
});

export default rootReducer;
